module.exports = __webpack_public_path__ + "img/_custom_contact.c5c8afbf.svg";